import React from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';
import { currentUser } from 'js/utils/user';
import routes from 'js/core_pre_webpack/routes';
import PremiumLock from 'js/header/FocusedNav/PremiumLock';
import DoubleDigitCountBubble from 'js/header/FocusedNav/DoubleDigitCountBubble';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import _MenuProfilePic from "AccountMenu-MenuProfilePic.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenu.tsx?styleId=MenuProfilePic";
import _Header from "AccountMenu-Header.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenu.tsx?styleId=Header";
import _UpgradeAnchor from "AccountMenu-UpgradeAnchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenu.tsx?styleId=UpgradeAnchor";
import _MenuList from "AccountMenu-MenuList.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenu.tsx?styleId=MenuList";
import _AnchorItem from "AccountMenu-AnchorItem.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenu.tsx?styleId=AnchorItem";
import _ItemName from "AccountMenu-ItemName.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenu.tsx?styleId=ItemName";
import _NotificationDot from "AccountMenu-NotificationDot.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AccountMenu.tsx?styleId=NotificationDot";


const SUPPORT_LINK = 'https://support.academia.edu';

const MenuProfilePic = /*#__PURE__*/styled("img", null, {
  displayName: "MenuProfilePic",
  styles: _MenuProfilePic
});

const Header = /*#__PURE__*/styled("a", null, {
  displayName: "Header",
  styles: _Header
});

const UpgradeAnchor = /*#__PURE__*/styled("a", null, {
  displayName: "UpgradeAnchor",
  styles: _UpgradeAnchor
});

const MenuList = /*#__PURE__*/styled("ul", null, {
  displayName: "MenuList",
  styles: _MenuList
});

const AnchorItem = /*#__PURE__*/styled("a", null, {
  displayName: "AnchorItem",
  styles: _AnchorItem
});

const ItemName = /*#__PURE__*/styled("span", null, {
  displayName: "ItemName",
  styles: _ItemName
});

const NotificationDot = /*#__PURE__*/styled("div", null, {
  displayName: "NotificationDot",
  styles: _NotificationDot
});

export type Props = {
  reactivate?: string;
  halfOffCoupon?: string;
  trialPrice?: string;
  mentionsCount: number;
  messagesCount: number;
  showLocalizationModal: () => void;
  hasUnseenReaders: boolean;
  notificationCount: number | null;
  setOpen: (openness: boolean) => void;
  showCommunityStandards?: boolean;
  showPremiumUpsells?: boolean;
  showPremiumOptions?: boolean;
  showNotificationBadges?: boolean;
};

export const TRIGGER = 'acct-mnu-btn';

const AccountMenu = (props: Props) => {
  const {
    showPremiumOptions = true,
    showPremiumUpsells = true,
    showNotificationBadges = true,
  } = props;

  const upgradeAnchorUrl = props.reactivate
    ? routes.checkout_url({
        premium_discount_coupon: props.halfOffCoupon,
        from_navbar: true,
        trigger: TRIGGER,
      })
    : routes.upgrade_url({
        feature: 'default',
        from_navbar: true,
        trigger: TRIGGER,
      });
  const upgradeAnchorText = props.reactivate
    ? 'Reactivate Premium'
    : 'Upgrade to Premium';

  return (
    <>
      <Header href={currentUser?.url}>
        {currentUser != null && (
          <MenuProfilePic src={$image_url(currentUser.photo)} />
        )}
        <div>{currentUser?.display_name}</div>
      </Header>
      {!currentUser?.premium && showPremiumUpsells && (
        <ImpressionWatcher source={TRIGGER}>
          <UpgradeAnchor href={upgradeAnchorUrl}>
            <PremiumLock color="white" />
            {upgradeAnchorText}
          </UpgradeAnchor>
        </ImpressionWatcher>
      )}
      <MenuList>
        <li>
          <AnchorItem href={currentUser?.url}>My Profile</AnchorItem>
        </li>
        <li>
          <AnchorItem
            href={routes.threads_url({
              from_navbar: true,
              trigger: TRIGGER,
            })}
          >
            My Messages
            {showNotificationBadges && (
              <DoubleDigitCountBubble count={props.messagesCount} />
            )}
          </AnchorItem>
        </li>
        <li>
          <AnchorItem
            href={routes.notifications_url({
              from_navbar: true,
              trigger: TRIGGER,
            })}
          >
            Notifications
            {showNotificationBadges && (
              <DoubleDigitCountBubble count={props.notificationCount} />
            )}
          </AnchorItem>
        </li>
        <li>
          <AnchorItem
            href={routes.reading_history_url({
              from_navbar: true,
              trigger: TRIGGER,
            })}
          >
            Reading History
          </AnchorItem>
        </li>
        <li>
          <AnchorItem
            href={routes.settings_url({
              from_navbar: true,
              trigger: TRIGGER,
            })}
          >
            Account Settings
          </AnchorItem>
        </li>
        <li>
          <AnchorItem
            href={routes.logout_url({
              from_navbar: true,
              trigger: TRIGGER,
            })}
          >
            Log Out
          </AnchorItem>
        </li>
      </MenuList>
      <Header>
        <img src={$image_url('header/focused/chart.svg')} />
        <div>My analytics</div>
      </Header>
      <MenuList>
        {showPremiumOptions && (
          <li>
            <AnchorItem
              href={routes.mentions_url({
                from_navbar: true,
                trigger: TRIGGER,
              })}
            >
              Mentions
              {props.mentionsCount > 0 ? (
                <DoubleDigitCountBubble count={props.mentionsCount} />
              ) : (
                <PremiumLock />
              )}
            </AnchorItem>
          </li>
        )}
        <li>
          <AnchorItem
            href={routes.analytics_dashboard_url({
              page_name: currentUser?.page_name,
              subdomain: currentUser?.domain_name,
              from_navbar: true,
              trigger: TRIGGER,
            })}
          >
            Basic Analytics
          </AnchorItem>
        </li>
        {showPremiumOptions && (
          <>
            <li>
              <AnchorItem
                href={
                  currentUser?.premium
                    ? routes.analytics_dashboard_url({
                        page_name: currentUser?.page_name,
                        subdomain: currentUser?.domain_name,
                        from_navbar: true,
                        trigger: TRIGGER,
                      })
                    : routes.upgrade_url({
                        feature: 'analytics',
                        from_navbar: true,
                        trigger: TRIGGER,
                      })
                }
              >
                Advanced Analytics
                <PremiumLock />
              </AnchorItem>
            </li>
            <li>
              <AnchorItem
                href={
                  currentUser?.premium
                    ? routes.analytics_dashboard_url({
                        page_name: currentUser?.page_name,
                        subdomain: currentUser?.domain_name,
                        from_navbar: true,
                        trigger: TRIGGER,
                      }) + '/activity/profile-visitors' // Not ideal, but this is how it is done elsewhere.
                    : routes.upgrade_url({
                        feature: 'PROFILE_VISITORS',
                        from_navbar: true,
                        trigger: TRIGGER,
                      })
                }
              >
                Profile Visitors
                <PremiumLock />
              </AnchorItem>
            </li>
            <li>
              <AnchorItem
                href={routes.readers_url({
                  from_navbar: true,
                  trigger: TRIGGER,
                })}
              >
                <ItemName>
                  Readers
                  {props.hasUnseenReaders && showNotificationBadges && (
                    <NotificationDot />
                  )}
                </ItemName>
                <PremiumLock />
              </AnchorItem>
            </li>
          </>
        )}
      </MenuList>
      <Header>
        <img src={$image_url('header/focused/open_book.svg')} />
        <div>Academia.edu Journals</div>
      </Header>
      <MenuList>
        <li>
          <AnchorItem
            href={routes.academia_journals_url({
              from_navbar: true,
              trigger: TRIGGER,
              source: TRIGGER,
            })}
          >
            Journals Home
          </AnchorItem>
        </li>
        <li>
          <AnchorItem
            href={routes.academia_journals_articles_url({
              from_navbar: true,
              trigger: TRIGGER,
              source: TRIGGER,
            })}
          >
            All Articles
          </AnchorItem>
        </li>
        <li>
          <AnchorItem
            href={routes.journals_submissions_url({
              from_navbar: true,
              trigger: TRIGGER,
              source: TRIGGER,
            })}
          >
            Publishing Hub
          </AnchorItem>
        </li>
      </MenuList>
      <Header>
        <img src={$image_url('header/focused/nodes.svg')} />
        <div>Networking</div>
      </Header>
      <MenuList>
        <li>
          <AnchorItem
            href={routes.friend_finder_index_url({
              from_navbar: true,
              trigger: TRIGGER,
            })}
          >
            Find Colleagues
          </AnchorItem>
        </li>
        <li>
          <AnchorItem
            href={routes.s_url({
              from_navbar: true,
              trigger: TRIGGER,
            })}
          >
            Start a Discussion
          </AnchorItem>
        </li>
      </MenuList>
      <Header>
        <img src={$image_url('header/focused/more_horizontal.svg')} />
        <div>More</div>
      </Header>
      <MenuList>
        <li>
          {props.showCommunityStandards && (
            <AnchorItem
              href={routes.community_standards_url({
                from_navbar: true,
                trigger: TRIGGER,
              })}
            >
              Community Standards
            </AnchorItem>
          )}
        </li>
        <li>
          <AnchorItem href={SUPPORT_LINK}>Help Center</AnchorItem>
        </li>
      </MenuList>
    </>
  );
};
export default AccountMenu;
